module.exports = __webpack_public_path__ + "img/bind-icon.c29630f5.png";